import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './LocaleMenuItem.less';
import {SVGIcon} from '@homeaway/react-svg';
import {CHECK__16} from '@homeaway/svg-defs';

/**
 * LocaleMenuItem
 *
 * Your final component will likely be made up of smaller sub-components.
 * Best-practice emphasizes the grouping of javascript, less, and unit tests
 * within the same directory for each sub-component. This keeps code modular
 * and makes navigating/mantaining code easier.
 *
 * You can see the importing of a less file above. Webpack is configured to
 * bundle the resultant CSS into the final javascript file. Host applications
 * only need to import the component's javascript and at runtime, the component
 * adds the CSS to the page. This is only possible for brand-agnostic components.
 * Today baseline is well equiped to provide all brand variation allowing your
 * component to not need any brand-specific styling. Baseline has various helper
 * classes for the typical colors which also make this a reality.
 */

class LocaleMenuItem extends Component {
    static propTypes = {
        /** Available locale option */
        locale: PropTypes.string.isRequired,
        /** Translated language name */
        languageName: PropTypes.string.isRequired,
        /** Translated country name */
        countryName: PropTypes.string.isRequired,
        /** True for current site locale */
        isActive: PropTypes.bool
    };

    static defaultProps = {
        locale: 'en_US',
        languageName: 'English',
        countryName: 'United States',
        isActive: false
    };

    get countryCode() {
        return this.props.locale.substr(3, 2).toLowerCase();
    }

    onLocaleClicked = () => {
        window.edap.push((edapInstance) => {
            edapInstance.trigger('generic.event', {
                eventcategory: 'react-site-header',
                eventaction: 'header-countryflag',
                eventlabel: this.countryCode,
                eventvalue: this.countryCode
            });

            edapInstance.trigger('header.link.click', {
                actionlocation: `header.flag.${this.countryCode}`
            });

            edapInstance.trigger('generic.event', {
                eventcategory: 'locale switcher',
                eventaction: 'locale flag clicked',
                eventlabel: this.props.locale
            });

            edapInstance.trigger('display_locale.selected', {
                action_location: 'locale selector'
            });
        });
    };

    renderLanguageName(locale) {
        if (locale === 'fr_CA') {
            return <span className="LocaleMenuItem__language-name">{`(${this.props.languageName})`}</span>;
        }

        return '';
    }

    render() {
        return (
            <div
                className="LocaleMenuItem"
                onClick={this.onLocaleClicked}
                onKeyPress={this.onLocaleClicked}
                role={'menuitem'}
                tabIndex={0}
            >
                {this.props.isActive && <SVGIcon className="LocaleMenuItem__check" inline markup={CHECK__16} />}
                <div>
                    <i className={`flag-${this.countryCode} flag-country`} aria-hidden="true"/>
                    <span className="LocaleMenuItem__country-name">{this.props.countryName}</span>
                    {this.renderLanguageName(this.props.locale)}
                </div>
            </div>
        );
    }
}

export default LocaleMenuItem;
